import _ from "lodash";
import {setFiltersFromParams} from "@/utils/filtersCommon";

export default {
  name: 'paginatorRequest',
  //---components
  components: {},
  props: {
    length: {
      required: true
    },
    current: {}
  },
  //---data
  data () {
    return {
      currentPageId: 1,
    }
  },
  //---hooks
  watch: {
    current: {
      immediate: true,
      handler: function (val) {
        if (val) {
          this.currentPageId = val;
        }
      }
    },
  },
  //---methods
  methods: {
    changeCurrentPage(){
      this.$emit('page-id', this.currentPageId)
    }
  }
}
